import { Component, computed, input } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';

export type InfoRowLabelVariant = 'paragraphBold' | 'largeParagraphBold';
export type InfoRowLayout = 'inline' | 'stacked';

@Component({
  selector: 'app-info-row',
  imports: [GcTextComponent, IpoTranslatePipe],
  templateUrl: './info-row.component.html',
  styleUrl: './info-row.component.scss',
})
export class InfoRowComponent {
  label = input.required<string>();
  value = input<string | number | null | undefined>();
  labelVariant = input<InfoRowLabelVariant>('paragraphBold');
  layout = input<InfoRowLayout>('stacked');

  displayValue = computed(() => {
    const value = this.value();
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    return value;
  });
}
